import React from "react";
import "./image.css";
var Image = function Image(props) {
  var _React$useState = React.useState(false),
      isLoaded = _React$useState[0],
      setIsLoaded = _React$useState[1];

  return React.createElement(
    React.Fragment,
    null,
    React.createElement("img", {
      className: typeof props.className != "undefined" ? props.className : "thumb",
      alt: typeof props.alt != "undefined" ? props.alt : null,
      src: typeof props.thumb != "undefined" ? props.thumb : require('./Image/loading.gif'),
      style: [{ visibility: isLoaded ? "hidden" : "visible" }, props.style]
    }),
    React.createElement("img", {
      onLoad: function onLoad() {
        setIsLoaded(true);
        if (typeof props.onLoad != "undefined") {
          props.onLoad();
        }
      },
      className: typeof props.className != "undefined" ? props.className : "full",
      style: [{ opacity: isLoaded ? 1 : 0 }, props.style],
      alt: typeof props.alt != "undefined" ? props.alt : null,
      src: props.src
    })
  );
};
export default Image;